import { Link } from "@inertiajs/react";
import { NavPageInterface } from "./nav";
import { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";

export const ConditionalLink = ({ inertia, href, ...props }) =>
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    inertia ? <Link href={href} {...props} /> : <a href={href} {...props} />;

export default function MobileNavItem({ item }: { item: NavPageInterface }) {
    const [open, setOpen] = useState(false);
    if (item?.children?.length) {
        return (
            <>
                <button
                    onClick={() => setOpen((prev) => !prev)}
                    className="flex items-center justify-between px-8 py-5 hover:bg-gray-50"
                >
                    <span className="ml-3 text-base font-medium text-gray-900">
                        {item.page.title}
                    </span>
                    {open ? (
                        <ChevronUpIcon
                            className="h-5 w-5 flex-none text-gray-400"
                            aria-hidden="true"
                        />
                    ) : (
                        <ChevronDownIcon
                            className="h-5 w-5 flex-none text-gray-400"
                            aria-hidden="true"
                        />
                    )}
                </button>
                {open && (
                    <div className="pl-8">
                        {(item?.page?.grouped
                            ? item.children.flatMap((item) => item.children)
                            : item.children
                        ).map((child) => (
                            <MobileNavItem item={child} key={child.page.id} />
                        ))}
                    </div>
                )}
            </>
        );
    }
    return (
        <ConditionalLink
            inertia={item?.page?.inertia}
            href={item.page.url}
            className="flex items-center px-8 py-5 hover:bg-gray-50"
        >
            <span className="ml-3 text-base font-medium text-gray-900">
                {item.page.title}
            </span>
        </ConditionalLink>
    );
}
